export default "__VITE_ASSET__BpcFmsx2__"